import React, {useState} from "react";
import {TestList, TestPageContext} from "../tests";

export default function FinishedTests(): any {
    const [reload, setReload] = useState(false)

    return (
        <TestPageContext.Provider value={{reload, setReload}}>
            <div className="w-full flex flex-col md:flex-row justify-center mx-5 pt-4 max-h-full">
                <TestList finished={true} active={false} title={"Finished Tests"}/>
            </div>
        </TestPageContext.Provider>
    );
}
